import { render } from "./PopupDanhSachVeChuyenLenh.vue?vue&type=template&id=6aa200da&scoped=true"
import script from "./PopupDanhSachVeChuyenLenh.vue?vue&type=script&lang=js"
export * from "./PopupDanhSachVeChuyenLenh.vue?vue&type=script&lang=js"

import "./PopupDanhSachVeChuyenLenh.vue?vue&type=style&index=0&id=6aa200da&scoped=true&lang=css"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aa200da"]])

export default __exports__